import { Hero } from "@/components/home/Hero";
import { Numbers } from "@/components/home/Numbers";
import { Manifesto } from "@/components/home/Manifesto";
import { Positions } from "@/components/home/Positions";
import { Wings } from "@/components/home/Wings";
import { FollowTheSun } from "@/components/home/FollowTheSun";
import { Play } from "@/components/home/Play";
import { SplitCTA } from "@/components/site/SplitCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Numbers />
      <Manifesto />
      <Positions />
      <Wings />
      <FollowTheSun />
      <Play />
      <SplitCTA />
    </div>
  );
}
